import { useParams, useSearchParams } from "react-router";
import { useLocale } from "@ncp/i18n";
import { ScreenRenderer, type ScreenSelection } from "@ncp/screens";

/** A screen configured in the Platform Console (Screen Builder), shown at /s/:screenKey. The picked record or case lives in the URL. */
export function ScreenPage() {
  const { screenKey } = useParams();
  const { locale } = useLocale();
  const [params, setParams] = useSearchParams();
  const selection: ScreenSelection = { record: params.get("record"), case: params.get("case") };
  const select = (next: ScreenSelection) => {
    const p = new URLSearchParams();
    if (next.record) p.set("record", next.record);
    if (next.case) p.set("case", next.case);
    setParams(p);
  };
  return (
    <div className="mx-auto max-w-6xl p-4 sm:p-6">
      <ScreenRenderer key={screenKey} surface="backoffice" locale={locale} screenKey={screenKey} selection={selection} onSelect={select} caseHref={(id) => `${import.meta.env.BASE_URL}cases/${id}`} />
    </div>
  );
}
